if (!customElements.get('td-bundle-faq-tabs')) {
  const SELECTORS = {
    tab: '[data-td-bundle-faq-tab]',
    panel: '[data-td-bundle-faq-panel]',
  };

  class TdBundleFaqTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.panels = [];
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(SELECTORS.tab));
      this.panels = Array.from(this.querySelectorAll(SELECTORS.panel));

      if (this.tabs.length < 2 || this.panels.length < 2) {
        return;
      }

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleTabKeydown);
      });
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleTabKeydown);
      });
    }

    handleTabClick(event) {
      this.activateTab(event.currentTarget);
    }

    handleTabKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);

      if (currentIndex === -1) return;

      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], { focus: true });
    }

    activateTab(nextTab, options = {}) {
      const { focus = false } = options;
      const nextTabHandle = nextTab.dataset.tdBundleFaqTab;

      this.tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tdBundleFaqPanel === nextTabHandle;
        panel.hidden = !isActive;
      });

      if (focus) {
        nextTab.focus();
      }
    }
  }

  customElements.define('td-bundle-faq-tabs', TdBundleFaqTabs);
}
